let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2qt5r")).then(() => parcelRequire('ghfmm'));